const key = Symbol();
const Display = Object.freeze({
    KEEP_EXISTING: "KEEP_EXISTING",
    SKIP: "SKIP",
    CALCULATE: "CALCULATE",
});

export { key, Display };
